module.exports = "<trix-editor input=\"trix-content\" placeholder=\"Write your fact here\"></trix-editor>\n<input id=\"trix-content\" type=\"hidden\" name=\"content\">"


//////////////////
// WEBPACK FOOTER
// ./project/components/fb-trix/fb-trix.html
// module id = 823
// module chunks = 3